import ErrorItem from "./ErrorItem";

function ErrorList(props) {
  return (
    <>
      {!!props.errors.length &&
        props.errors.map((error, i) => (
          <ErrorItem key={i} index={i} error={error} />
        ))}
    </>
  );
}

export default ErrorList;
